import { createContext, useContext } from 'react';

export const EmitterContext = createContext({});

export const useEmitterContext = () => useContext(EmitterContext);
